var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    id: "master_svg0_2706_10505"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "99.28571581840515%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.10000000149011612
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,2.65487C14.0708,2.65487,17.3451,5.9292,17.3451,10C17.3451,14.0708,14.0708,17.3451,10,17.3451C5.9292,17.3451,2.65487,14.0708,2.65487,10C2.65487,5.9292,5.9292,2.65487,10,2.65487ZM10,0C4.51328,0,0,4.51328,0,10C0,15.4867,4.51328,20,10,20C15.4867,20,20,15.4867,20,10C20,4.51328,15.4867,0,10,0Z",
    fill: "url(#master_svg0_2706_10505)",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLoading);
export default __webpack_public_path__ + "static/media/white-loading.cbabe6154bb845aa7a53e303bbcc9dbd.svg";
export { ForwardRef as ReactComponent };